import React from 'react';
import './Card.scss';

const Card = (props) => {
    return (
        <div className="card custom-card shadow">
            <div className="card-img-container">
                <img src={props.img} className="card-image card-img-top" loading="lazy" alt={props.title} />
            </div>
            <div className="card-body">
                <h5 className="card-title">{props.title}</h5>
            </div>
            <div className="card-footer bg-white border-0 pb-4">
                <span>
                    <i className="fas fa-star text-warning me-2" />
                    {props.rating}
                </span>
            </div>
        </div>
    );
};

export default Card;
